export enum Source {
  Custom = 'custom',
  Dapp = 'dapp',
  Detected = 'detected',
}
